import { useCallback, useEffect, useState } from 'react';
import { get, TooManyRequestsError } from '../js/api';
import Page from '../js/generic/Page';
import Layout from '../js/layout/Layout';
import useUser from '../js/login/userContext';
import delay from '../js/utils/delay';
import { MainSlot } from '../js/utils/Slot';
import WaitingRoom, { bodyClass } from '../js/waiting-room/WaitingRoom';

export interface WaitingRoomResponse {
    title: string;
    subtitle: string;
    mainMessage: string;
    reopenMessage: string;
    lastUpdatedMessage: string;
    lastUpdated: string;
    refreshInterval: number;
}

export default function () {
    const { user, logout } = useUser();
    const [props, setProps] = useState<WaitingRoomResponse>();

    const getStatus = useCallback(async () => {
        try {
            await get('/vmpws/v2/vmp/status');
            // if success, reload the page
            location.reload();
        } catch (error) {
            if (error instanceof TooManyRequestsError) {
                error.preventDefault();
                const vmpWaitingRoom = (error as TooManyRequestsError<{ vmpWaitingRoom: WaitingRoomResponse }>).errors.vmpWaitingRoom;
                setProps(vmpWaitingRoom);
                await delay(vmpWaitingRoom.refreshInterval * 1000);
                getStatus();
            } else {
                console.error(error);
            }
        }
    }, []);

    useEffect(() => {
        // This ensures we update status when the user logs in or out, and on page load
        if (user !== undefined) {
            getStatus();
        }
    }, [user]);

    if (!props?.title) {
        return <Page isSpinning />;
    }

    return <WaitingRoom {...props} user={user} logout={logout} />;
}

export function StaticLayout() {
    return (
        <Layout title="Venterom" className={bodyClass}>
            <MainSlot />
        </Layout>
    );
}
